module.exports = __webpack_public_path__ + "static/media/icon-calendar-white.fbb50a92.svg";